export default "__VITE_ASSET__a247662d__"